import script from "./Steps.vue?vue&type=script&setup=true&lang=js"
export * from "./Steps.vue?vue&type=script&setup=true&lang=js"

import "./Steps.vue?vue&type=style&index=0&id=2bb1d2b9&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bb1d2b9"]])

export default __exports__